<template>
    <div>
    <div id="user_settings_page" class="centered" v-if="loaded">
        <div id="top">
            <h2>הגדרות משתמש</h2>
            <div class="user_name">{{user_data.display_name}}</div>

            <!-- <Cropper v-if="editCrops && !isNull($store.user.artists)" :circle="true" :sid="$store.user.artists[0].pic" :thumbs="[{name: 'circle', circle:true, width:200, height:200},{name: 'width', width:200, height:100}]" />

            <div class="user_pic" :style="'background-image:url('+ (!isNull($store.user.artists) ? $store.user.artists[0].pic_tumb_big : '') +')'" @click="editCrops=!editCrops">
                <div class="btn"><i class="fas fa-camera"></i></div>
            </div> -->

            <Gallery v-model="user_data.pic" :token="pic_token" :max="1" />

        </div>
        <div class="user_settings">
            <div class="col-md-7">
                <div class="col-md-6">
                    
                    <md-input v-model="user_data.display_name" name="name" label="שם מלא:"></md-input>
                    
                </div>
                 <div class="col-md-6">
                    
                    <md-input v-model="user_data.username" name="username" label="אימייל:"></md-input>
                    
                </div>
                <div class="clr"></div>
                 <div class="col-md-6">
                    <md-input v-model="user_data.phone" name="phone" pattern="[0-9]{10}" label="מספר פלאפון:"></md-input>
                    
                </div>
                 <!-- <div class="col-md-6">
                    
                    <label> סגנון מוזיקלי</label>
                    <md-input v-model="user_data.genre_ids"></md-input>
                    
                <div class="clr"></div>
                </div> -->
                <div class="col-md-6">
                    <md-input v-model="user_data.password" type="password" name="password" label="סיסמה:"></md-input>
                    
                </div>
                <div class="col-md-12">
                    <div><md-checkbox v-model="user_data.allow_msgs_from_media">אני מאשר/ת קבלת הודעות פרטיות מאנשי מדיה</md-checkbox></div>
                    <div><md-checkbox v-model="user_data.allow_msgs_from_artists">אני מאשר/ת קבלת הודעות פרטיות מאמנים </md-checkbox></div>

                    <div><md-checkbox v-model="user_data.media_get_mail">מקבל עידכונים שוטפים במייל</md-checkbox></div>
                    <div><md-checkbox v-model="user_data.media_get_weekly_mail">מקבל עידכונים שבועיים במייל</md-checkbox></div>
                    
                </div>

                    
            <h3>פושים</h3>
            <div><md-switch v-model="user_data.push_chat">הודעות חדשות בצ'אט</md-switch></div>
            <div v-if="true || get_me().type == 'media'"><md-switch v-model="user_data.push_lt">לינקטונים חדשים</md-switch></div>
            <div v-if="get_me().type == 'artist'"><md-switch v-model="user_data.push_artist_stats">עדכונים לגבי צפיות בלינקטון שלך</md-switch></div>
            
            </div>
            
        </div>
        
    </div>
    <div class="centered">
        <a class="btn_send" @click="save">שמור</a>
    </div>
</div>
</template>

<script>
// import Cropper from '../components/cropper.vue';
import Gallery from '@/components/gallery.vue';


export default {
    components: { Gallery /*Cropper*/},
  data(){
    return {
        editCrops: false,
        media_message:false,
        user_id: this.$store.user.id,
        artist_message:true,
        user_data: {},
        pic_token: false,
        loaded: false
    }
  },
  mounted(){
       this.api({ action: 'settings_page' }, (data) => { 
        this.user_data = data.data;
        this.pic_token = data.data.pic_token;
      
        this.loaded = true;
      
      } );
  },
  methods:{
      save(){
          
       this.api({ action: 'save_settings', data: this.user_data }, () => { 
        //this.user_data = data.data
        this.alert('הפרטים נשמרו בהצלחה');
      
      } );
      }

  }
  
  
}
</script>
<style  lang="scss" scooped>
.btn_send{ cursor: pointer; background: #ff1661;color: #fff !important;padding: 15px 50px;font-weight: 600;font-size: 22px;border-radius: 45px; display: inline-block;}
#user_settings_page{
    #top{position: relative;}

    .col-md-7{padding-right: 0;padding-left: 30px;}
    // .col-md-7::after{position: absolute;content: '';height: 100%;width: 2px;background: #eeeeee;left: 13px;top: 40px;}
    .col-md-6{padding-right: 0;}
    h2{font-size: 30px;font-weight: 600;margin-bottom: 10px;}
    .user_name{color: #8e8d8d;font-size: 25px;margin-bottom: 20px;}
    .user_pic{    height: 150px; width: 150px; background-repeat: no-repeat; background-size: cover; background-position: center; border-radius: 100%;position: relative;}
    .user_pic .btn{   padding: 0; display: block;z-index: 3;border-radius: 100%;width: 45px;height: 45px;background-image: linear-gradient(135deg, #ff1661 13%, #00b7ff 123%);
    position: absolute;bottom: -2px;left: 0px;color: #fff;line-height: 51px;text-align: center;
    .fa-camera{font-size: 22px;}
    }
    .md-field .md-input{height: 50px;background: #eee !important;border-radius: 5px; padding-right:15px;}
    .md-field .md-input.disabeld{background: #f7f7f7 !important;}
    .md-field.md-theme-default:after{display: none;}
    .md-field.md-theme-default label{left: auto;right: 10px;}
    .md-toggle-password{right: auto;left: 10px;top: 24px;}
    .md-checkbox{margin: 10px 0 0 0 ;}
    .md-radio{margin: 0;}
    .checkboxes{
        &{position:relative;}
        span{position: absolute;right: 0px;font-size: 20px;font-weight: 500;color: #8e8d8d;}
    }
}
</style>